import { useState } from 'react'
import { Tabs, Tab } from '@mui/material'
import Statuses from '../components/settings/statuses/Statuses'
import Tags from '../components/settings/tags/Tags'
import PaymentPage from './PaymentPage'
import ShowcasePage from './ShowcasePage'
import AvitoAccountsSettings from '../components/settings/integrations/AvitoAccountsSettings'
import RequestSources from '../components/settings/requests/RequestSources'
import RequireClientPolicySettings from '../components/settings/requests/RequireClientPolicySettings'
import CustomFieldDefinitionSettings from '../components/customFields/CustomFieldDefinitionSettings'

function OptionsPage() {
	const [selectedTab, setSelectedTab] = useState(0)

	const handleTabChange = (event, newValue) => {
		setSelectedTab(newValue)
	}

	return (
		<div>
			<RequireClientPolicySettings />
			<Tabs
				value={selectedTab}
				onChange={handleTabChange}
				indicatorColor='primary'
				textColor='primary'
				variant='scrollable'
				scrollButtons='auto'
				aria-label='Разделы настроек'
			>
				<Tab label='Тарифы и оплата' />
				<Tab label='Теги и статусы' />
				<Tab label='Персональная витрина' />
				<Tab label='Интеграции' />
				<Tab label='Пользовательские поля' />
				{/* временно скрыт, пока нет перевода */}
				{/* <Tab label='Язык и страна' /> */}
			</Tabs>
			{/* <Box className='mt-4 p-4 rounded shadow'> */}
			{selectedTab === 1 && (
				<>
					<div>
						<Statuses />
					</div>
					<div>
						<Tags />
					</div>
					<RequestSources />
				</>
			)}
			{selectedTab === 0 && <div className='ml-5 mt-5'>
				<PaymentPage/>
				</div>}
			 {selectedTab === 2 && (
				<div>
					<ShowcasePage />
				</div>
			)} 
			{selectedTab === 3 && <AvitoAccountsSettings />}
			{selectedTab === 4 && <CustomFieldDefinitionSettings />}
			{/* 	</Box> */}
		</div>
	)
}

export default OptionsPage
